import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

import { decodeId, Select2Data } from "../../../utils/common";



export const Share_Your_Experience = createAsyncThunk(
  "home/Share_Your_Experience",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Commons.Share_Your_Experience, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllStoreBanners = createAsyncThunk(
  "home/AllStoreBanners",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllStoreBanners);

      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const AllFrameCategory = createAsyncThunk(
  "home/AllFrameCategory",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllFrameCategory);

      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const AllFrames = createAsyncThunk(
  "home/AllFrame",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllFrame}?f_category_id=${filter?.f_category_id || ""}`);

      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const ReturnReasons = createAsyncThunk(
  "home/ReturnReason",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.ReturnReason);

      return await Select2Data(res?.data, "return_reason_id");
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const CancelReasons = createAsyncThunk(
  "home/CancelReason",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.CancelReason);

      return await Select2Data(res?.data, "cancel_reason_id");
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const RoomCancelReasons = createAsyncThunk(
  "home/RoomCancelReason",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.RoomCancelReason);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const EventFormStatus = createAsyncThunk(
  "home/EventFormStatus",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.EventFormStatus);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const SpandanFormStatus = createAsyncThunk(
  "home/SpandanFormStatus",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.SpandanFormStatus);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const AtOmTapovan = createAsyncThunk(
  "home/At_Om_Tapovan",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.At_Om_Tapovan);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const OurMission = createAsyncThunk(
  "home/OurMission",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.OurMission);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const OurVission = createAsyncThunk(
  "home/OurVission",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.OurVission);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllLanguage = createAsyncThunk(
  "home/AllLanguage",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllLanguage);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const UPcomingFestival = createAsyncThunk(
  "home/UPcomingFestival",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.ComingFestival);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const BlogCategory = createAsyncThunk(
  "home/BlogCategory",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.BlogCategory);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const WelcomeText = createAsyncThunk(
  "home/welcome-text",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.welcomeText);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const OurOfferings = createAsyncThunk(
  "home/our-offerings",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.OurOfferings);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const GurudevContent = createAsyncThunk(
  "home/gurudev-content",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.GurudevContent);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllCenters = createAsyncThunk(
  "home/centers",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.Centers);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllRoomTypes = createAsyncThunk(
  "home/RoomTypes",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.RoomType);

      return Select2Data(res?.data, "room_type_id");
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const getCoupons = createAsyncThunk(
  "home/add-coupons",
  async ({ amount = "" }, { rejectWithValue }) => {
    try {
      const couponData = await GET(`${APIS.Commons.COUPON}?amount=${amount}`);

      return couponData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllEvent = createAsyncThunk(
  "home/event",
  async (filter = {}, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.Event}?country_id=${filter.country_id ||
        ""}&state_id=${filter.state_id || ""}&event_category_id=${filter.event_category_id || ""}`
      );
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllEventCategories = createAsyncThunk(
  "home/event-categories",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.EventCategory);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const SingleEventCategories = createAsyncThunk(
  "home/SingleEvent-cat",
  async (data, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.EventCategory}/${data?.id}`);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const SingleEvent = createAsyncThunk(
  "home/SingleEvent",
  async (data, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.Event}/${data?.id}`);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);


export const EventAttendance = createAsyncThunk(
  "home/EventAttendance",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Commons.EventAttendance, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const EventRegistration = createAsyncThunk(
  "home/EventRegistration",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Commons.EventRegistration, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const EventRegistrationValidation = createAsyncThunk(
  "home/EventRegistrationval",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Commons.EventRegistration}-validate`, data);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const EventPrograms = createAsyncThunk(
  "home/EventPrograms",
  async (data, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.EventPrograms}/${data?.id}`);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllInsightExclusive = createAsyncThunk(
  "home/insightExclusive",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.InsightExclusive);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const AllInsightVideo = createAsyncThunk(
  "home/insightVideo",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.InsightVideo);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const allInsightsArticle = createAsyncThunk(
  "home/InsightsArticle",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.InsightsArticle}?startDate=${filter?.startDate ||
        ""}&endDate=${filter?.endDate || ""}`
      );
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const SingleInsightsArticle = createAsyncThunk(
  "home/SingleInsightsArticle",
  async (data, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.InsightsArticle}/${data?.id}`);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const SpiritualInsight = createAsyncThunk(
  "home/SpiritualInsight",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${filter.single
          ? APIS.Commons.SingleSpiritualInsight
          : APIS.Commons.SpiritualInsight
        }?startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
      );
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const OurCoreVision = createAsyncThunk(
  "home/OurCoreVision",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.OurCoreVision);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const AllPravachan = createAsyncThunk(
  "home/pravachan",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPravachan);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllBlog = createAsyncThunk(
  "home/AllBlog",
  async (data, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllBlog}${data?.id ? `/${data?.id}` : ""
        }?blog_category_id=${decodeId(data?.blog_category_id) || ""}`
      );
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const SingleBlog = createAsyncThunk(
  "home/SingleBlog",
  async (data, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllBlog}/${data?.id}`);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const GurujiWisdom = createAsyncThunk(
  "home/GurujiWisdom",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.GurujiWisdom);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const QuoteOfTheDay = createAsyncThunk(
  "home/QuoteOfTheDay",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.QuoteOfTheDay);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const SpiritualTruth = createAsyncThunk(
  "home/SpiritualTruth",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.SpiritualTruth);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const GuruShorts = createAsyncThunk(
  "home/GuruShorts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.GuruShorts);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllSeva = createAsyncThunk(
  "home/AllSeva",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllSeva);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllChants = createAsyncThunk(
  "home/AllChants",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllChants}/?chant_type_id=${filter?.chant_type_id ||
        ""}&pod_status=${filter?.pod_status || false}`
      );
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllChantsAlbum = createAsyncThunk(
  "home/AllChantsAlbum",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllChantsAlbum
        }/?chant_type_id=${filter?.chant_type_id || ""}`
      );
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const AllTestimonials = createAsyncThunk(
  "home/AllTestimonials",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTestimonials);
      return res?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err.message);
    }
  }
);
export const AllMeditaion = createAsyncThunk(
  "common/masters/all-meditaions",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllMeditaion);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const SingleMeditaion = createAsyncThunk(
  "common/masters/single-meditaions",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllMeditaion}/${id}`);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllBanner = createAsyncThunk(
  "common/masters/all-banner",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllBanner);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllPermmission = createAsyncThunk(
  "common/masters/all-permission",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllPermmission);

      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllRoles = createAsyncThunk(
  "common/masters/all-role",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllRoles}?name=${filter}`);
      console.log(res, "res res rrrrrrrrrrrrrrrrrrrr");

      return await Select2Data(res.data, "role_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllGenders = createAsyncThunk(
  "common/masters/all-genders",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllGenders}?name=${filter}`);

      return await Select2Data(res.data, "gender_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllCountry = createAsyncThunk(
  "common/masters/all-country",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCountry}?name=${filter}`);

      return await Select2Data(res.data, "country_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// State - Get All (for a specific country)
export const AllState = createAsyncThunk(
  "common/masters/all-state/:id",
  async ({ countryId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllState}/${countryId}?name=${name}`
      );

      // You can adjust Select2Data if necessary
      return await Select2Data(res.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// City - Get All (for a specific state)
export const AllCity = createAsyncThunk(
  "common/masters/all-city/:id",
  async ({ stateId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCity}/${stateId}?name=${name}`);
      return await Select2Data(res.data, "city_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Pincode - Get All (for a specific city)
export const AllPincode = createAsyncThunk(
  "common/masters/all-pincode/:id",
  async ({ cityId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllPincode}/${cityId}?name=${name}`
      );
      return await Select2Data(res.data, "pincode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllArea = createAsyncThunk(
  "common/masters/all-area/:id",
  async ({ pincodeId, name = "" }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllArea}/${pincodeId}?name=${name}`
      );
      return await Select2Data(res.data, "area_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllHelpCategory = createAsyncThunk(
  "common/masters/all-help-category",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllHelpCategory}?name=${filter}`);

      return await Select2Data(res.data.data, "help_category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// export const AllGalleryCAtegory = createAsyncThunk(
//   "common/masters/all-gallery-category",
//   async (filter = "", { rejectWithValue }) => {
//     try {
//       const res = await GET(
//         `${APIS.Commons.AllGalleryCAtegory}?name=${filter}`
//       );

//       return await Select2Data(res.data.data, "gallery_category_id");
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const AllGalleryCategory = createAsyncThunk(
  "common/masters/all-gallery-category",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Commons.AllGalleryCategory}?name=${filter}`
      );
      return await Select2Data(res.data.data, "gallery_category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllCategory = createAsyncThunk(
  "common/masters/all-category",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllCategory}?name=${filter}`);
      console.log(res, "resresresres");

      return await Select2Data(res.data, "p_category_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllTestimonial = createAsyncThunk(
  "/common/masters/all-testimonials",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTestimonial);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllOurTeam = createAsyncThunk(
  "/common/masters/all-our-team",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllOurTeam);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllArticleNews = createAsyncThunk(
  "/common/masters/all-article",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllArticleNews);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllGallery = createAsyncThunk(
  "/common/masters/all-gallery",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllGallery);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllInnerGalary = createAsyncThunk(
  "common/all_inner_galary",
  async (categoryId, { rejectWithValue }) => {
    try {
      // API endpoint — adjust if needed
      const res = await GET(
        `${APIS.Commons.AllInnerGalary}?gallery_category_id=${categoryId}`
      );
      return res.data.data; // return only the array of images
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllTrustSafety = createAsyncThunk(
  "/common/masters/all-trust-safety",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllTrustSafety);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllHelpQuestion = createAsyncThunk(
  "/common/masters/all-help-question",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllHelpQuestion);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllStates = createAsyncThunk(
  "common/masters/all-state",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllStates}?name=${filter}`);

      return await Select2Data(res.data.data, "state_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllVolunteer = createAsyncThunk(
  "/website/common/volunteering",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllVolunteer}?name=${filter}`);
      return res.data;
      // return await Select2Data(res.data, "volunteer_detail_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSIngleVolunteer = createAsyncThunk(
  "/website/common/get-volunteering",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllVolunteer}/${id}`);
      return res;
      // return await Select2Data(res.data, "volunteer_detail_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Country - Get All
export const AllVolunteerMode = createAsyncThunk(
  "common/masters/all-volunteer-mode",
  async (filter = "", { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.AllVolunteerMode}?name=${filter}`);

      return await Select2Data(res.data.data, "volunteer_mode_id");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// New: Get Fund Raises by Category (for "All Categories" use empty category_id)
export const GetFundRaisesByCategory = createAsyncThunk(
  "common/fundraises-by-category",
  async (categoryId = "", { rejectWithValue }) => {
    try {
      const query = categoryId ? `?category_id=${categoryId}` : "";
      const res = await GET(
        `${APIS.Commons.GetFundRaisesByCategory}/get-fundraise${query}`
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetFundRaisesByid = createAsyncThunk(
  "common/fundraises-by-id",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Commons.GetFundRaisesById}/${id}}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AllVolunteerPositon = createAsyncThunk(
  "/common/masters/volunteer-position",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllVolunteerPositon);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllDaysOfService = createAsyncThunk(
  "/common/masters/days-of-service",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllDaysOfService);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AllHoursOfService = createAsyncThunk(
  "/common/masters/hour-of-service",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Commons.AllHoursOfService);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "common",
  initialState: {
    all_country: [],
    all_genders: [],
    all_state: [],
    all_city: [],
    all_pincode: [],
    all_area: [],
    all_help_category: [],
    all_gallery_category: [],
    all_category: [],
    all_testimonial: [],
    all_social_links: [],
    all_our_team: [],
    all_article_news: [],
    all_gallery: [],
    all_inner_galary: [],

    all_trust_safety: [],
    all_help_question: [],
    all_states: [],
    all_volunteer_mode: [],
    all_volunteer: [],
    volunteer: {},
    all_fundraises: [],
    get_fundraise: [],

    quote_of_day: [],
    all_banners: [],
    spiritual_truth: [],
    meditations: [],
    meditation: [],
    guru_shorts: [],
    all_seva: [],
    all_chants: [],
    all_chants_album: [],
    all_testimonials: [],
    guruji_wisdom: [],
    core_vision: [],
    all_blogs: [],
    single_blog: {},
    all_pravachan: [],
    spiritual_insights: [],
    all_insight_article: [],
    insight_article: {},
    all_insight_videos: [],
    all_insight_exclusives: [],
    all_events: [],
    all_event_programs: [],
    all_event_categories: [],
    event: {},
    event_category: {},
    all_centers: [],
    all_room_Types: [],

    addCoupons: [],
    all_volunteer_position: [],
    all_days_of_service: [],
    all_hours_of_service: [],

    all_offerings: [],
    welcomeText: [],
    coming_festival: {},

    gurudev_content: [],
    blog_categories: [],

    languages: [],
    at_om_tapovan: [],
    our_vission: [],
    our_mission: [],
    event_form_status: {},
    spandan_form_status: {},


    room_cancel_reasons: [],
    cancel_reasons: [],
    return_reasons: [],
    all_frame_cats: [],
    all_frames: [],
    all_store_banner: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Handling all actions for GetSingle, Create, Update, Delete

      .addCase(AllStoreBanners.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllStoreBanners.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_store_banner = action.payload || [];
      })
      .addCase(AllStoreBanners.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllFrameCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFrameCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_frame_cats = action.payload || [];
      })
      .addCase(AllFrameCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllFrames.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllFrames.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_frames = action.payload || [];
      })
      .addCase(AllFrames.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(ReturnReasons.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(ReturnReasons.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.return_reasons = action.payload || [];
      })
      .addCase(ReturnReasons.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(CancelReasons.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CancelReasons.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.cancel_reasons = action.payload || [];
      })
      .addCase(CancelReasons.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(RoomCancelReasons.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(RoomCancelReasons.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.room_cancel_reasons = action.payload || [];
      })
      .addCase(RoomCancelReasons.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SpandanFormStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SpandanFormStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.spandan_form_status = action.payload || [];
      })
      .addCase(SpandanFormStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(EventFormStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(EventFormStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.event_form_status = action.payload || [];
      })
      .addCase(EventFormStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AtOmTapovan.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AtOmTapovan.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.at_om_tapovan = action.payload || [];
      })
      .addCase(AtOmTapovan.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(OurVission.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(OurVission.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.our_vission = action.payload || [];
      })
      .addCase(OurVission.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(OurMission.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(OurMission.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.our_mission = action.payload || [];
      })
      .addCase(OurMission.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllLanguage.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllLanguage.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.languages = action.payload || [];
      })
      .addCase(AllLanguage.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(BlogCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(BlogCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.blog_categories = action.payload || [];
      })
      .addCase(BlogCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UPcomingFestival.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UPcomingFestival.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.coming_festival = action.payload || {};
      })
      .addCase(UPcomingFestival.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(WelcomeText.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(WelcomeText.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.welcomeText = action.payload || [];
      })
      .addCase(WelcomeText.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(OurOfferings.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(OurOfferings.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_offerings = action.payload || [];
      })
      .addCase(OurOfferings.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GurudevContent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GurudevContent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.gurudev_content = action.payload || [];
      })
      .addCase(GurudevContent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllEvent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllEvent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_events = action.payload || [];
      })
      .addCase(AllEvent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllEventCategories.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllEventCategories.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_event_categories = action.payload || [];
      })
      .addCase(AllEventCategories.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllArea.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllArea.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_area = action.payload || [];
      })
      .addCase(AllArea.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(EventPrograms.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(EventPrograms.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_event_programs = action.payload || [];
      })
      .addCase(EventPrograms.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(getCoupons.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getCoupons.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.addCoupons = action.payload || [];
      })
      .addCase(getCoupons.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllRoomTypes.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllRoomTypes.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_room_Types = action.payload || [];
      })
      .addCase(AllRoomTypes.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCenters.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCenters.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_centers = action.payload || [];
      })
      .addCase(AllCenters.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SingleEventCategories.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SingleEventCategories.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.event_category = action.payload || [];
      })
      .addCase(SingleEventCategories.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(SingleEvent.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SingleEvent.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.event = action.payload || [];
      })
      .addCase(SingleEvent.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllInsightExclusive.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllInsightExclusive.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_insight_exclusives = action.payload || [];
      })
      .addCase(AllInsightExclusive.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllInsightVideo.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllInsightVideo.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_insight_videos = action.payload || [];
      })
      .addCase(AllInsightVideo.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(allInsightsArticle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(allInsightsArticle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_insight_article = action.payload || [];
      })
      .addCase(allInsightsArticle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SingleInsightsArticle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SingleInsightsArticle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.insight_article = action.payload || [];
      })
      .addCase(SingleInsightsArticle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SingleBlog.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SingleBlog.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.single_blog = action.payload || [];
      })
      .addCase(SingleBlog.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SpiritualInsight.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SpiritualInsight.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.spiritual_insights = action.payload || [];
      })
      .addCase(SpiritualInsight.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(OurCoreVision.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(OurCoreVision.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.core_vision = action.payload || [];
      })
      .addCase(OurCoreVision.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllPravachan.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPravachan.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pravachan = action.payload || [];
      })
      .addCase(AllPravachan.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBlog.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBlog.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_blogs = action.payload || [];
      })
      .addCase(AllBlog.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllMeditaion.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllMeditaion.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.meditations = action.payload || [];
      })
      .addCase(AllMeditaion.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SingleMeditaion.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SingleMeditaion.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.meditation = action.payload || [];
      })
      .addCase(SingleMeditaion.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GurujiWisdom.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GurujiWisdom.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.guruji_wisdom = action.payload || [];
      })
      .addCase(GurujiWisdom.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllBanner.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllBanner.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_banners = action.payload || [];
      })
      .addCase(AllBanner.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(QuoteOfTheDay.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(QuoteOfTheDay.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.quote_of_day = action.payload || [];
      })
      .addCase(QuoteOfTheDay.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(SpiritualTruth.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(SpiritualTruth.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.spiritual_truth = action.payload || [];
      })
      .addCase(SpiritualTruth.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GuruShorts.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GuruShorts.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.guru_shorts = action.payload || [];
      })
      .addCase(GuruShorts.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllSeva.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllSeva.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_seva = action.payload || [];
      })
      .addCase(AllSeva.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllChants.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllChants.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_chants = action.payload || [];
      })
      .addCase(AllChants.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllChantsAlbum.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllChantsAlbum.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_chants_album = action.payload || [];
      })
      .addCase(AllChantsAlbum.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTestimonials.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTestimonials.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_testimonials = action.payload || [];
      })
      .addCase(AllTestimonials.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCountry.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCountry.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_country = action.payload || [];
      })
      .addCase(AllCountry.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllGenders.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllGenders.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_genders = action.payload || [];
      })
      .addCase(AllGenders.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_category = action.payload || [];
      })
      .addCase(AllCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllState actions
      .addCase(AllState.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllState.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_state = action.payload || [];
      })
      .addCase(AllState.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllCity.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllCity.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_city = action.payload || [];
      })
      .addCase(AllCity.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // Handling AllPincode actions
      .addCase(AllPincode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllPincode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_pincode = action.payload || [];
      })
      .addCase(AllPincode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllHelpCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllHelpCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_help_category = action.payload || [];
      })
      .addCase(AllHelpCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // .addCase(AllGalleryCAtegory.pending, (state) => {
      //   state.status = IDS.SLICESTATUS.Loading;
      // })
      // .addCase(AllGalleryCAtegory.fulfilled, (state, action) => {
      //   state.status = IDS.SLICESTATUS.Succeeded;
      //   state.all_gallery_category = action.payload || [];
      // })
      // .addCase(AllGalleryCAtegory.rejected, (state, action) => {
      //   state.status = IDS.SLICESTATUS.Failed;
      //   state.error = action.payload;
      // })

      .addCase(AllTestimonial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTestimonial.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_testimonial = action.payload || [];
      })
      .addCase(AllTestimonial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllOurTeam.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllOurTeam.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_our_team = action.payload || [];
      })
      .addCase(AllOurTeam.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllArticleNews.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllArticleNews.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_article_news = action.payload || [];
      })
      .addCase(AllArticleNews.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllGallery.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllGallery.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_gallery = action.payload || [];
      })
      .addCase(AllGallery.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllInnerGalary.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllInnerGalary.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_inner_galary = action.payload || [];
      })
      .addCase(AllInnerGalary.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllTrustSafety.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllTrustSafety.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_trust_safety = action.payload || [];
      })
      .addCase(AllTrustSafety.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllHelpQuestion.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllHelpQuestion.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_help_question = action.payload || [];
      })
      .addCase(AllHelpQuestion.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllStates.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllStates.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_states = action.payload || [];
      })
      .addCase(AllStates.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllVolunteerMode.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllVolunteerMode.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_volunteer_mode = action.payload || [];
      })
      .addCase(AllVolunteerMode.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSIngleVolunteer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSIngleVolunteer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.volunteer = action.payload.data || [];
      })
      .addCase(GetSIngleVolunteer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllVolunteer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllVolunteer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_volunteer = action.payload || [];
      })
      .addCase(AllVolunteer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetFundRaisesByCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetFundRaisesByCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_fundraises = action.payload || [];
      })
      .addCase(GetFundRaisesByCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AllVolunteerPositon.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllVolunteerPositon.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_volunteer_position = action.payload || {};
      })
      .addCase(AllVolunteerPositon.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllDaysOfService.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllDaysOfService.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_days_of_service = action.payload || {};
      })
      .addCase(AllDaysOfService.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AllHoursOfService.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AllHoursOfService.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.all_hours_of_service = action.payload || {};
      })
      .addCase(AllHoursOfService.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
